import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { AssetMetadataDto } from '../../asset-metadata/dtos/asset-metadata.dto';
import { AssetReservationStatusEnum } from '../enums/asset-reservation-status.enum';

import { AssetReservationLinksDto } from './asset-reservation-links.dto';

/**
 * Asset reservation DTO for lists
 */
@CaslSubject(AppSubjectEnum.ASSET_RESERVATION)
export class AssetReservationListDto extends BaseProtoDto {
  code!: string;
  qrCode?: string;
  status!: AssetReservationStatusEnum;
  startsAt!: Date;
  endsAt!: Date;
  accountId!: number;
  tenantOrgId?: string;
  assetName?: string;
  assetMetadata?: AssetMetadataDto[];
  pickupAreaName?: string;
  dropOffAreaName?: string;
  pricingItems?: PricingItemDto[];
  links?: AssetReservationLinksDto;
  files?: FileDto[];

  computedPeriod?: ComputedPeriodDurationDto;
  @TransformFloat() computedTotalNet?: number;
  @TransformFloat() computedTotalTax?: number;
  @TransformFloat() computedTotalGross?: number;
  @TransformFloat() computedDiscountNet?: number;
  @TransformFloat() computedDiscountTax?: number;
  @TransformFloat() computedDiscountGross?: number;
  @TransformFloat() computedStandardNet?: number;
  @TransformFloat() computedStandardTax?: number;
  @TransformFloat() computedStandardGross?: number;
  @TransformFloat() computedExtrasNet?: number;
  @TransformFloat() computedExtrasTax?: number;
  @TransformFloat() computedExtrasGross?: number;
  @TransformFloat() computedSavingsAmount?: number;
  @TransformFloat() computedSavingsPercentage?: number;
  @TransformFloat() computedOriginalStandardAmount?: number;
  @TransformFloat() computedCommissionNet?: number;
}
